module.exports = __webpack_public_path__ + "media/images/common/support3-f5d7ab675908aa20ecef0eab87da443b.png";